import {inject, InjectionToken} from "@angular/core";
import {DOCUMENT} from "@angular/common";

export const WINDOW_REF_TOKEN = new InjectionToken('window default token', {
  factory: () => {
    const documentRef = inject(DOCUMENT);
    if(!documentRef.defaultView) {
      throw new Error('Window is undefined');
    }
    return documentRef.defaultView
  },
})
